<template>
  <div>
    <div
      v-if="parsedNotifications.length > 0"
      class="community_notifications_list"
    >
      <slot name="title">
        as
      </slot>
      <div
        v-for="notification in parsedNotifications"
        :key="notification.id"
        class="notification__block pb-2"
      >
        <CommunityNotificationItem
          :notification="notification"
          :openInNewWindow="openInNewWindow"
          :magicCode="magicCode"
          :isStudio="isStudio"
        />
      </div>
      <div class="text-center" v-if="isLoading">
        <HMSpinner></HMSpinner>
      </div>
    </div>
    <slot v-else name="no-data"></slot>
  </div>
</template>

<script lang="ts">
import CommunityNotificationItem from './CommunityNotificationItem.vue';
import { useCommunityStore } from '@/stores';
import api from '@/api/community';

export default {
  name: 'CommunityNotificationsList',
  components: {
    CommunityNotificationItem,
  },
  props: {
    isStudio: {
      type: Boolean,
      default: false,
    },
    openInNewWindow: {
      type: Boolean,
      default: false,
    },
    magicCode: {
      type: String,
      default: null,
    },
    maxNotifications: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      isLoading: true,
      notifications: [],
    };
  },
  computed: {
    parsedNotifications() {
      const result = [];
      const results = this.notifications?.results || [];
      if (this.maxNotifications) {
        results.splice(this.maxNotifications);
      }
      results.forEach(n => {
        const actorCount = n.actor_count;
        const activityCount = n.activity_count;
        const verb = n.verb;
        const firstActivity = n.activities[0];
        result.push({
          verb: verb,
          time: firstActivity.time,
          actor: firstActivity.actor,
          actorCount: actorCount,
          activityCount: activityCount,
          extraData: firstActivity.extra_data,
          object: firstActivity.object,
          activities: n.activities,
          isSeen: n.is_seen,
          id: n.id,
        });
      });

      return result;
    },
  },
  methods: {
    async loadStudioNotifications() {
      this.notifications = await api.loadNotifications(
        false,
        0,
        this.maxNotifications,
        true
      );
    },
    async loadTeacherNotifications() {
      this.notifications = await api.loadNotifications(
        false,
        0,
        this.maxNotifications,
        false
      );
    },
    async loadNotifications() {
      const notificationsAction = this.isStudio
        ? this.loadStudioNotifications
        : this.loadTeacherNotifications;
      this.isLoading = true;
      try {
        await notificationsAction();
      } finally {
        this.isLoading = false;
      }
    },
  },
  watch: {
    isStudio: {
      handler() {
        this.loadNotifications();
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/components-variables.scss';

.community_notifications_list {
  overflow: auto;

  &::-webkit-scrollbar {
    width: 6px;
    background-color: $light-gray;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    background-color: white;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: $light-gray;
  }
}
</style>
